const prefix = `yi.lf.`;

export const loggerFlagStorageKeys = {
  ENTITLEMENTS: `${prefix}entitlements` as const,
  BROOKLYN: `${prefix}brooklyn` as const,
  NEW_RELIC: `${prefix}new_relic` as const,
};
